interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  tone?: "danger" | "primary";
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  tone = "danger",
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4">
      <button
        type="button"
        aria-label="Cancelar"
        onClick={onCancel}
        className="absolute inset-0 cursor-pointer bg-foreground-950/50"
      ></button>
      <div className="relative w-full max-w-sm rounded-lg border border-background-200 bg-background-50 p-6">
        <span
          className={`flex h-11 w-11 items-center justify-center rounded-full ${
            tone === "danger"
              ? "bg-accent-100 text-accent-700"
              : "bg-primary-100 text-primary-700"
          }`}
        >
          <i className={`text-xl ${tone === "danger" ? "ri-alert-line" : "ri-question-line"}`}></i>
        </span>
        <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
          {title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{description}</p>
        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="cursor-pointer whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold text-foreground-600 transition-colors hover:bg-background-100"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`cursor-pointer whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold text-white transition-colors disabled:opacity-60 ${
              tone === "danger"
                ? "bg-accent-600 hover:bg-accent-700"
                : "bg-primary-500 hover:bg-primary-600"
            }`}
          >
            {loading ? "Procesando..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}